import { fileShield_02 } from "@tql/ui-components-react/untitled/icons";

import type { Claims } from "~/features/ar-dashboard/schemas/dashboard-schemas.ts";

import { ArDashboardCard } from "../ar-dashboard-card/ar-dashboard-card.tsx";
import { IndicatorCard } from "../indicator-card/indicator-card.tsx";
import styles from "./claims-card.module.css";

type ClaimsCardProps = {
	data: Claims;
	isLoading?: boolean;
	isFetching?: boolean;
};

const ClaimsCardContent = ({
	data,
	isLoading = false,
	isFetching = false,
}: ClaimsCardProps) => {
	const showSkeleton = isLoading || isFetching;

	return (
		<div className={styles.claimsCard}>
			<div className={styles.indicatorCardWrapper}>
				<IndicatorCard
					border={true}
					count={data.validation}
					isLoading={showSkeleton}
					label={"Validation"}
					size={"small"}
					type={"info"}
				/>
			</div>
			<div className={styles.indicatorCardWrapper}>
				<IndicatorCard
					border={true}
					count={data.activeClaims}
					isLoading={showSkeleton}
					label={"Active Claims"}
					size={"small"}
					type={"info"}
				/>
			</div>
			<div className={styles.indicatorCardWrapper} style={{ flex: 1.2 }}>
				<IndicatorCard
					border={true}
					count={data.resolvedClaims}
					isLoading={showSkeleton}
					label={"Resolved Claims"}
					size={"small"}
					type={"info"}
				/>
			</div>
		</div>
	);
};

export const ClaimsCard = ({
	data,
	isLoading,
	isFetching,
}: ClaimsCardProps) => {
	return (
		<ArDashboardCard
			content={
				<ClaimsCardContent
					data={data}
					isFetching={isFetching}
					isLoading={isLoading}
				/>
			}
			icon={fileShield_02}
			title={"Claims"}
		/>
	);
};
